import { createStyles } from '@material-ui/core/styles';

const styles = createStyles((theme) => ({
  boxList: {
    width: '375px',
    maxHeight: '477px',
    backgroundColor: '#FFFFFF',
    position: 'fixed',
    right: '65px',
    bottom: '55px',
    zIndex: '9999',
    boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.2)',
    borderRadius: '12px',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      width: '320px',
      right: '25px'
    },
    '@media(max-width: 355px)': {
      width: '300px',
      right: '10px'
    },
  },
  header: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #E5E5EA',
    padding: '16px',
    // width 100% + padding se desbordaba 32px y el botón de cerrar, anclado a la derecha, quedaba recortado.
    boxSizing: 'border-box',
    position: 'relative',
    '& .MuiTypography-root': {
      color: '#000000',
      fontWeight: 600,
      fontSize: '17px',
    },
  },
  btnClose: {
    position: 'absolute',
    right: '12px',
    top: '10px',
    color: '#8E8E93',
    minWidth: '32px',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    padding: '4px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    '& svg': {
      fontSize: '24px'
    }
  },
  list: {
    overflowY: 'auto',
    flex: 1,
    padding: 0,
  },
  row: {
    padding: '12px 16px',
    borderBottom: '1px solid #F1F1F4',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#F8F8FA',
    },
  },
  rowSelected: {
    backgroundColor: '#EAF5FC',
  },
  reference: {
    fontWeight: 600,
    fontSize: '14px',
    color: '#000000',
  },
  subtitle: {
    fontSize: '12px',
    color: '#8E8E93',
    marginTop: '2px',
  },
  company: {
    fontSize: '11px',
    color: '#AEAEB2',
    marginTop: '2px',
  },
  badge: {
    display: 'inline-block',
    backgroundColor: '#FF3B30',
    color: '#FFFFFF',
    fontSize: '11px',
    fontWeight: 600,
    borderRadius: '10px',
    padding: '2px 7px',
    marginLeft: '8px',
  },
  empty: {
    padding: '24px 16px',
    textAlign: 'center',
    color: '#8E8E93',
    fontSize: '13px',
  },
}));

export default styles;
